var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from "react";
import ProductStoresView from "../presentation/stores";
import axios from 'axios';
import { connect } from "react-redux";
import CONSTS from "../consts";
const pcluster = require('points-cluster');
const _ = require('lodash');
const supercluster = pcluster.default;
const MAP = {
    defaultZoom: 6,
    defaultCenter: { lat: 53.542741, lng: -113.4912073 }
};
export class ProductStores extends React.Component {
    constructor(props) {
        super(props);
        this.getProduct = () => {
            let oDataPath = CONSTS.APIURL;
            let query = `${oDataPath}Products(${this.props.id})`;
            axios.get(query)
                .then(response => {
                this.setState({
                    name: response.data.Name,
                });
            });
        };
        this.getStores = () => {
            let oDataPath = CONSTS.APIURL;
            let query = "";
            if (this.state.mapOptions.bounds == null) {
                query = `${oDataPath}Products(${this.props.id})/Suppliers`;
            }
            else {
                var bounds = this.state.mapOptions.bounds;
                var boundsText = `east=${bounds.ne.lng || 0},west=${bounds.nw.lng || 0},north=${bounds.nw.lat || 0},south=${bounds.se.lat || 0}`;
                query = `${oDataPath}Products(${this.props.id})/ConnectMobile.Web.AllSuppliersWithinBounds(${boundsText})`;
            }
            axios.get(query)
                .then((response) => {
                let favoriteStores = this.props.favoriteStores;
                let stores = _.chain(response.data.value)
                    .sortBy([
                    function (o) { return -favoriteStores.indexOf(o.Id); }
                ])
                    .map((store, index) => {
                    return Object.assign(Object.assign({}, store), { storeIndex: index });
                }).value();
                this.setState({
                    stores: stores,
                });
                this.createClusters();
            });
        };
        this.getLocation = (position) => {
            this.setState({
                mapOptions: Object.assign(Object.assign({}, this.state.mapOptions), { center: { lat: position.coords.latitude, lng: position.coords.longitude }, zoom: 16 })
            });
        };
        this.clusterMarkerClick = (position) => {
            this.setState({
                mapOptions: Object.assign(Object.assign({}, this.state.mapOptions), { center: { lat: position.lat, lng: position.lng }, zoom: this.state.mapOptions.zoom + 2 })
            });
        };
        this.MarkerClick = (position) => {
            this.setState({
                mapOptions: Object.assign(Object.assign({}, this.state.mapOptions), { center: { lat: position.lat, lng: position.lng }, zoom: 16 })
            });
        };
        this.updateSelected = (newStore) => {
            this.setState({ selected: newStore });
        };
        this.getClusters = () => {
            let markersData = this.state.stores.map((store, index) => {
                return {
                    lat: store.Latitude,
                    lng: store.Longitude,
                    storeIndex: store.storeIndex + 1,
                    id: store.Id,
                    storeInfo: store
                };
            });
            const clusters = supercluster(markersData, {
                minZoom: 0,
                maxZoom: 16,
                radius: 60,
            });
            return clusters(this.state.mapOptions);
        };
        this.createClusters = () => {
            this.setState({
                clusters: this.state.mapOptions.bounds
                    ? this.getClusters().map(({ wx, wy, numPoints, points }) => ({
                        lat: wy,
                        lng: wx,
                        numPoints,
                        id: `${numPoints}_${points[0].id}`,
                        points,
                    }))
                    : [],
            });
        };
        this.handleMapChange = ({ center, zoom, bounds }) => {
            this.setState({
                mapOptions: {
                    center,
                    zoom,
                    bounds,
                },
            }, () => {
                this.createClusters();
                this.getStores();
            });
        };
        this.updateToggle = (toggle) => {
            this.setState({ toggleMobile: toggle });
        };
        this.updateAddressText = (newAddress) => {
            this.setState({ addressText: newAddress }, this.getAddressLatLng);
        };
        this.state = {
            stores: [],
            name: "",
            selected: "",
            clusters: [],
            mapOptions: {
                center: MAP.defaultCenter,
                zoom: MAP.defaultZoom,
            },
            toggleMobile: false,
            addressText: ""
        };
    }
    componentDidMount() {
        this.getProduct();
        if (this.props.favoriteStores) {
            this.getStores();
        }
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.favoriteStores !== this.props.favoriteStores) {
            this.getStores();
        }
    }
    getAddressLatLng() {
        return __awaiter(this, void 0, void 0, function* () {
            var geocoder = new google.maps.Geocoder();
            geocoder.geocode({
                address: this.state.addressText,
                bounds: {
                    east: -109,
                    south: 48,
                    west: -121,
                    north: 61,
                }
            }, (results, status) => {
                if (status === google.maps.GeocoderStatus.OK && results != null && results.length > 0) {
                    this.setState({
                        mapOptions: Object.assign(Object.assign({}, this.state.mapOptions), { center: { lat: results[0].geometry.location.lat(), lng: results[0].geometry.location.lng() }, zoom: 13 })
                    }, this.getStores);
                }
            });
        });
    }
    render() {
        return (React.createElement(ProductStoresView, Object.assign({}, this.state, { getLocation: this.getLocation, updateToggle: this.updateToggle, updateSelected: this.updateSelected, handleMapChange: this.handleMapChange, MarkerClick: this.MarkerClick, clusterMarkerClick: this.clusterMarkerClick, updateAddressText: this.updateAddressText })));
    }
}
;
export function mapStateToProps({ shoppingList, authenticated, signInModal, favoriteStores }) {
    return {
        favoriteStores
    };
}
export default connect(mapStateToProps)(ProductStores);
//# sourceMappingURL=stores.js.map